import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import './data.css';
import { Row, Col, Form, Icon, message } from 'antd';
import { Breadcrumb, Select, DatePicker, Button, Spin } from 'antd';
import moment from 'moment';
import { apis } from '../api/index.js';
import i18n from 'i18next';
import echarts from 'echarts/lib/echarts';
// 引入柱状图
import 'echarts/lib/chart/bar';
// 引入折线图
import 'echarts/lib/chart/line';
// 引入饼图
import 'echarts/lib/chart/pie';
//引入图例组件
import 'echarts/lib/component/legend';
// 引入提示框和标题组件
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
// 引入中国地图
import 'echarts/map/js/china';
import geoJson from 'echarts/map/json/china.json';
import { geoCoordMap, ownProvienceDot, ownProvienceData } from './geo'; //provienceData
import { provienceList } from './geo';
import loading from '../imgs/data/loading2.gif';

import 安徽 from './map/安徽.json';
import 甘肃 from './map/甘肃.json';
import 广西 from './map/广西.json';
import 贵州 from './map/贵州.json';
import 河北 from './map/河北.json';
import 河南 from './map/河南.json';
import 湖北 from './map/湖北.json';
import 湖南 from './map/湖南.json';
import 吉林 from './map/吉林.json';
import 江西 from './map/江西.json';
import 辽宁 from './map/辽宁.json';
import 山西 from './map/山西.json';
import 四川 from './map/四川.json';
import 西藏 from './map/西藏.json';
import 新疆 from './map/新疆.json';
import 云南 from './map/云南.json';
import { formatDate, changeListWidth, getDay } from '../utils';
import { breadItem } from '../utils';

import CountUp from 'react-countup';
import ConnectedHeader from '../connectedComponents/ConnectedHeader.js';
import ConnectedMenu from '../connectedComponents/ConnectedMenu.js';
const { Option } = Select;
const { MonthPicker } = DatePicker;

//地图配置
var pos = { leftPlus: 85, leftCur: 0, left: 10, top: 10 };
var line = [[0, 0], [8, 11], [0, 22]];
var style = {
  font: '12px "Microsoft YaHei", sans-serif',
  textColor: '#2185C7',
  lineColor: 'rgba(147, 235, 248, .8)',
};

class DataForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id,
      sexStat: [],
      allStat: [],
      aiStat: [],
      datePickerType: 'month',
      isopen: false,
      year: null,
      userProducts: [],
      currentProduct: {},
      barData: {},
      mapData: [],
      mapAlertSetInterval: true,
      title: '',
      yearValue: null,
      showLoading: true,
      provinces: {
        河北,
        山西,
        辽宁,
        吉林,
        安徽,
        江西,
        河南,
        湖北,
        湖南,
        广西,
        四川,
        贵州,
        云南,
        西藏,
        甘肃,
        新疆,
      },
      name: [],
      idx: 0,
      dateRange: '',
      chartHeight: 0,
      mapHeight: 0,
      canvasHeight: 0,
      mapCanvasHeight: 0,
    };
  }

  static propTypes = {
    user: PropTypes.object,
    history: PropTypes.object,
    match: PropTypes.object,
    form: PropTypes.object,
  };

  componentWillReceiveProps(newProps) {
    const _this = this;
    if (newProps.match.url !== this.props.match.url) {
      setTimeout(function() {
        _this.setState({ id: newProps.match.params.id });
        const initValue = { datePickerType: 'month', monthDate: new Date() };
        _this.getUserProducts(initValue);
      }, 5);
    }
  }

  componentDidMount() {
    const initValue = {
      datePickerType: 'month',
      monthDate: new Date(),
    };

    this.getUserProducts(initValue);
    this.setState({ dateRange: formatDate(new Date(), 'YYYY年MM月') });
    this.props.form.setFieldsValue({
      monthDate: moment(new Date(), 'YYYY年MM月'),
    });

    this.windowResize();
    const _this = this;
    window.onresize = function() {
      _this.windowResize();
      if (_this.myIncreaseChart) _this.myIncreaseChart.resize();
      if (_this.mySexChart) _this.mySexChart.resize();
      if (_this.myRankChart) _this.myRankChart.resize();
      if (_this.myYangChart) _this.myYangChart.resize();
      if (_this.myMapChart) _this.myMapChart.resize();
    };
  }

  windowResize = () => {
    const chartHeight = parseInt(document.body.clientHeight - 270) / 2;
    const mapHeight = parseInt(document.body.clientHeight - 255);
    const canvasHeight = chartHeight - 55;
    const mapCanvasHeight = mapHeight - 55;
    this.setState({ chartHeight, mapHeight, canvasHeight, mapCanvasHeight });
  };

  getUserProducts = value => {
    const { id } = this.state;
    const products = window.store.getState().api.user.info.products;
    let currentProduct = '';
    products.forEach(item => {
      if (parseInt(id) === item.productId) currentProduct = item;
    });
    this.setState({
      currentProduct,
      showLoading: true,
      title: currentProduct.productName,
    });
    this.getBoardOtherData(currentProduct, value);
  };

  getBoardOtherData = (currentProduct, value) => {
    let post = {};
    if (value) {
      post.areaCountry = '0';
      post.aiProductType = currentProduct.productId;
      if (value.area) post.areaProvince = value.area.split('-')[0];
      if (value.datePickerType === 'month' && value.monthDate) {
        const month = formatDate(value.monthDate, 'YYYY-MM');
        const fromTime = month + '-1 0:0:0';
        const lastDate = new Date(
          month.split('-')[0],
          month.split('-')[1],
          0
        ).getDate();
        const toTime = month + '-' + lastDate + ' 23:59:59';
        post.fromTime = fromTime;
        post.toTime = toTime;
      } else if (value.datePickerType === 'year' && value.yearDate) {
        const year = formatDate(value.yearDate, 'YYYY');
        const fromTime = year + '-1-1 0:0:0';
        const toTime = year + '-12-31 23:59:59';
        post.fromTime = fromTime;
        post.toTime = toTime;
      }
    } else {
      const fromTime = getDay(-30) + ' 0:0:0';
      const toTime = getDay(0) + ' 23:59:59';
      post = {
        aiProductType: currentProduct.productId,
        fromTime,
        toTime,
        areaCountry: '0',
      };
    }

    apis.boardOtherData(post).then(res => {
      if (res.code === '0') {
        let allStat5 = [],
          aiStat5 = [];
        for (let i in res.data.allStat) {
          if (i < 7) {
            let label = '',
              value = '';
            for (let j in res.data.allStat[i]) {
              label = j;
              value = res.data.allStat[i][j];
            }
            allStat5.push({ value, label });
          } else {
            break;
          }
        }
        for (let i in res.data.aiStat) {
          if (i < 7) {
            let label = '',
              value = '';
            for (let j in res.data.aiStat[i]) {
              label = j;
              value = res.data.aiStat[i][j];
            }
            aiStat5.push({ value, label });
          } else {
            break;
          }
        }
        this.setState({
          sexStat: res.data.sexStat,
          allStat: allStat5,
          aiStat: aiStat5,
          mapData: res.data.mapstat,
          title: i18n.t(currentProduct.productName),
        });
        this.setSexChart();
        this.setRankChart();
        this.setYangRankChart();
        const opt = {
          bgColor: 'rgba(0, 0, 0, 0)', // 画布背景色
          mapName: value && value.area ? value.area.split('-')[1] : '中国', // 地图名
          goDown: true, // 是否下钻
          mapData: geoJson,
          data: [],
          callback: function(name, option, instance) {},
        };
        this.setState({ lastOpt: opt });
        if (opt.mapName !== '中国') {
          let { name } = this.state;
          this.myMapChart = echarts.init(
            document.getElementById('mapChartLight')
          );

          let option = this.setMapOption(opt, this.myMapChart);
          if (name.length > 1) {
            this.resetOption(
              this.myMapChart,
              this.state.lastOption,
              name[0],
              this.state.lastOpt
            );
          }
          this.setState({ lastOption: option });
          let _this = this;
          _this.clickMapChart(
            value.area.split('-')[1],
            this.myMapChart,
            this.myMapChart,
            opt,
            option
          );
        } else {
          this.setMapCharts(opt);
        }

        this.getBoardXdaysData(currentProduct.productId, post);
        this.getBoardTodayData(currentProduct.productId, post);
      } else {
        message.error(res.message);
        if (res.code === '1009') this.props.history.push('/login');
      }
    });
  };

  getBoardTodayData = (id, data) => {
    const fromTime = getDay(0) + ' 0:0:0';
    const toTime = getDay(0) + ' 23:59:59';
    const post = {
      aiProductType: id,
      fromTime,
      toTime,
      areaCountry: '0',
    };
    if (data.areaProvince) post.areaProvince = data.areaProvince;
    apis.boardTodayData(post).then(res => {
      if (res.code === '0') {
        this.setState({ barData: res.data });
      } else {
        message.error(res.message);
        if (res.code === '1009') this.props.history.push('/login');
      }
    });
  };

  getBoardXdaysData = (id, data) => {
    const fromTime = getDay(-6) + ' 0:0:0';
    const toTime = getDay(0) + ' 23:59:59';
    const post = {
      aiProductType: id,
      fromTime,
      toTime,
      areaCountry: '0',
    };
    if (data.areaProvince) post.areaProvince = data.areaProvince;
    apis.boardXdaysData(post).then(res => {
      if (res.code === '0') {
        this.setState({
          lineChartData: res.data.dataMap || [],
          showLoading: false,
        });
        this.setIncreaseChart();
      } else {
        message.error(res.message);
        if (res.code === '1009') this.props.history.push('/login');
      }
    });
  };
  sexData = () => {
    const { sexStat } = this.state;
    const data = [['product', i18n.t('male'), i18n.t('female')]];
    sexStat.forEach(item => {
      let f = 0,
        m = 0,
        name = '';
      for (let i in item) {
        name = i;
        f = item[i].F;
        m = item[i].M;
      }
      const current = [i18n.t(name), m, f];
      data.push(current);
    });
    return data;
  };

  setSexChart = () => {
    // 基于准备好的dom，初始化echarts实例
    if (!document.getElementById('sexChartLight')) return;
    this.mySexChart = echarts.init(document.getElementById('sexChartLight'));
    // 绘制图表
    this.mySexChart.setOption({
      legend: {
        show: true,
        right: 10,
        top: 10,
        orient: 'horizontal',
        itemWidth: 11,
        itemHeight: 7,
        itemGap: 20,
        data: [
          {
            name: i18n.t('male'),
            icon: 'rect',
            textStyle: { fontSize: 12, color: '#8C8C8C' },
          },
          {
            name: i18n.t('female'),
            icon: 'rect',
            textStyle: { fontSize: 12, color: '#8C8C8C' },
          },
        ],
      },
      tooltip: {},
      dataset: { source: this.sexData() },
      xAxis: {
        type: 'category',
        axisLine: { lineStyle: { color: '#EFECF0' } },
        axisLabel: {
          textStyle: {
            fontFamily: 'Microsoft YaHei',
            color: 'rgba(0,0,0,0.45)',
          },
        },
      },
      yAxis: {
        type: 'value',
        axisLine: { show: false },
        splitLine: {
          show: true,
          lineStyle: { color: '#ECE9EC' },
        },
        axisLabel: {
          textStyle: {
            fontFamily: 'Microsoft YaHei',
            color: 'rgba(0,0,0,0.45)',
          },
        },
      },
      series: [
        {
          type: 'bar',
          barWidth: 11,
          name: i18n.t('male'),
          itemStyle: { color: '#5B8FF9' },
          barGap: '30%',
        },
        {
          type: 'bar',
          barWidth: 11,
          name: i18n.t('female'),
          itemStyle: { color: '#EC7846' },
          barGap: '30%',
        },
      ],
    });
  };

  setAiCntData = () => {
    const { lineChartData } = this.state;
    const allData = [],
      positiveData = [];
    if (lineChartData) {
      lineChartData.forEach(line => {
        for (let i in line) {
          allData.push(line[i].aiAllCnt);
          positiveData.push(line[i].aiPositiveCnt);
        }
      });
    }

    return { allData, positiveData };
  };

  setIncreaseChart = () => {
    const xData = [];
    for (let i = -6; i <= 0; i++) {
      xData.push(getDay(i, 'YMD'));
    }
    const increaseChartLight = document.getElementById('increaseChartLight');
    if (!increaseChartLight) return;

    this.myIncreaseChart = echarts.init(increaseChartLight);
    this.myIncreaseChart.setOption({
      legend: {
        data: ['传片患者', '阳性患者'],
        textStyle: { fontSize: 12, color: '#8C8C8C' },
        right: 10,
        orient: 'vertical',
      },
      xAxis: {
        type: 'category',
        data: xData,
        axisLabel: { textStyle: { color: 'rgba(0,0,0,0.45)' } },
        axisLine: { lineStyle: { color: '#EEEBEE' } },
      },
      yAxis: {
        type: 'value',
        axisLabel: { textStyle: { color: 'rgba(0,0,0,0.45)' } },
        splitLine: { lineStyle: { color: 'rgb(255,255,255,0.3)' } },
        axisLine: { lineStyle: { color: '#EEEBEE' } },
      },
      series: [
        {
          name: '传片患者',
          data: this.setAiCntData().allData,
          type: 'line',
          itemStyle: { color: '#648CE7' },
        },
        {
          name: '阳性患者',
          data: this.setAiCntData().positiveData,
          type: 'line',
          itemStyle: { color: '#CB6C49' },
        },
      ],
    });
  };

  setRankChart = () => {
    const COLOR = ['#5B8FF9', '#5AD8A6'];
    if (!document.getElementById('rankChartLight')) return;
    this.myRankChart = echarts.init(document.getElementById('rankChartLight'));
    const data = [];
    for (let i = this.state.allStat.length - 1; i >= 0; i--) {
      data.push(this.state.allStat[i]);
    }
    this.myRankChart.setOption({
      tooltip: {
        trigger: 'axis',
        axisPointer: { type: 'shadow' },
      },
      grid: {
        top: 10,
        left: '3%',
        right: 40,
        bottom: 0,
        containLabel: true,
      },
      xAxis: { type: 'value', show: false },
      yAxis: {
        show: true,
        type: 'category',
        axisLine: { show: false },
      },
      series: [
        {
          name: 'label',
          type: 'bar',
          barWidth: 15,
          label: {
            show: true,
            position: 'insideLeft',
            color: 'rgba(0,0,0,0.45)',
            fontSize: 12,
          },
          data: data.map(item => {
            return {
              value: 0,
              label: {
                formatter() {
                  return item.label;
                },
              },
            };
          }),
        },
        {
          name: 'value',
          type: 'bar',
          barWidth: 15,
          label: {
            show: true,
            position: 'right',
            fontSize: 12,
            offset: [5, 0],
            formatter({ value }) {
              return `${value}`;
            },
          },
          data: data.map(({ value }, index) => {
            let color = COLOR[index % COLOR.length];
            return {
              value,
              label: { color: '#595959' },
              itemStyle: { color },
            };
          }),
        },
      ],
    });
  };

  setYangRankChart = () => {
    const COLOR = ['#FA7373', '#73A0FA'];
    const yangRankChartLight = document.getElementById('yangRankChartLight');
    if (!yangRankChartLight) return;
    this.myYangChart = echarts.init(yangRankChartLight);
    const data = [];
    for (let i = this.state.aiStat.length - 1; i >= 0; i--) {
      data.push(this.state.aiStat[i]);
    }
    this.myYangChart.setOption({
      tooltip: {
        trigger: 'axis',
        axisPointer: { type: 'shadow' },
      },
      grid: {
        top: 10,
        left: '3%',
        right: 40,
        bottom: 0,
        containLabel: true,
      },
      xAxis: { type: 'value', show: false },
      yAxis: {
        show: true,
        type: 'category',
        axisLine: { show: false },
      },
      series: [
        {
          name: 'label',
          type: 'bar',
          barWidth: 15,
          label: {
            show: true,
            position: 'insideLeft',
            color: 'rgba(0,0,0,0.45)',
            fontSize: 12,
          },
          data: data.map(item => {
            return {
              value: 0,
              label: {
                formatter() {
                  return item.label;
                },
              },
            };
          }),
        },
        {
          name: 'value',
          type: 'bar',
          barWidth: 15,
          label: {
            show: true,
            position: 'right',
            fontSize: 12,
            offset: [5, 0],
            formatter({ value }) {
              return `${value}`;
            },
          },
          data: data.map(({ value }, index) => {
            let color = COLOR[index % COLOR.length];
            return {
              value,
              label: { color: '#595959' },
              itemStyle: { color },
            };
          }),
        },
      ],
    });
  };

  convertData = data => {
    var res = [];
    for (var i = 0; i < data.length; i++) {
      var geoCoord = geoCoordMap[data[i].areaName];
      if (geoCoord) {
        res.push({
          name: data[i].areaName.replace('省', ''),
          value: data[i].dicomCount,
        });
      }
    }
    return res;
  };

  setMapOption = (opt, myChart) => {
    const { mapData, name } = this.state;
    let convertMapData = this.convertData(mapData);
    ownProvienceData.forEach(data => {
      let flag = true;
      convertMapData.forEach(item => {
        if (item.name === data.name) {
          flag = false;
          data.value = item.value + 100;
        }
      });
      if (flag) data.value = 100;
    });

    let _this = this;

    var option = {
      backgroundColor: opt.bgColor,
      animation: true,
      progressiveThreshold: 3,
      graphic: [
        {
          type: 'group',
          left: pos.left,
          top: pos.top - 4,
          children: [
            {
              type: 'line',
              left: 0,
              top: -20,
              shape: { x1: 0, y1: 0, x2: 60, y2: 0 },
              style: { stroke: style.lineColor },
            },
            {
              type: 'line',
              left: 0,
              top: 20,
              shape: { x1: 0, y1: 0, x2: 60, y2: 0 },
              style: { stroke: style.lineColor },
            },
          ],
        },
        {
          id: name[0],
          type: 'group',
          left: pos.left + 2,
          top: pos.top,
          children: [
            {
              type: 'polyline',
              left: 90,
              top: -12,
              shape: { points: line },
              style: { stroke: 'transparent', key: name[0] },
              onclick: function() {
                var name = this.style.key;
                _this.resetOption(myChart, option, name, opt);
              },
            },
            {
              type: 'text',
              left: 0,
              top: 'middle',
              style: {
                text: '中国',
                textAlign: 'center',
                fill: style.textColor,
                font: style.font,
              },
              onclick: function() {
                _this.resetOption(myChart, option, '中国', opt);
              },
            },
            {
              type: 'text',
              left: 0,
              top: 10,
              style: {
                text: 'ZHONGGUO',
                textAlign: 'center',
                fill: style.textColor,
                font: '12px "Microsoft YaHei", sans-serif',
              },
              onclick: function() {
                _this.resetOption(myChart, option, '中国', opt);
              },
            },
          ],
        },
      ],
      tooltip: {
        trigger: 'item',
        formatter: function(params) {
          const value = params.value || 0;
          if (value > 0) {
            const realValue = value - 100;
            const name = params.name;
            return `${name}<br/>传片数              ${realValue}<br/>AI筛查数           ${realValue}`;
          } else {
            return '暂无业务';
          }
        },
        color: '#FFFFFF',
        verticalAlign: 'top',
        position: 'top',
        padding: [10, 20],
        lineHeight: 32,
        backgroundColor: '#3D85D6',
      },
      grid: {},
      geo: {
        map: opt.mapName,
        aspectScale: 0.8,
        roam: true,
        scaleLimit: { min: 1.2, max: 15 },
        zoom: 1.2,
        label: {
          //标签样式设置
          normal: { show: false, color: '#FFFFFF', verticalAlign: 'bottom' },
          //鼠标移上去的样式
          emphasis: { show: false, color: '#FFFFFF' },
        },
        itemStyle: {
          normal: {
            borderColor: 'rgba(147, 235, 248, 1)',
            borderWidth: 0.5,
            areaColor: '#89BDE6',
          },
          emphasis: { areaColor: '#389BB7', borderWidth: 0 },
        },
      },
      series: [
        {
          type: 'effectScatter',
          coordinateSystem: 'geo',
          showEffectOn: 'render',
          rippleEffect: { period: 15, scale: 4, brushType: 'fill' },
          hoverAnimation: true,
          itemStyle: { normal: { color: '#89BDE6' } },
          data: ownProvienceData,
        },
        {
          type: 'map',
          mapType: 'china',
          geoIndex: 0,
          label: {
            normal: { show: true },
            emphasis: { show: true },
          },
          data: ownProvienceData,
        },
        {
          type: 'effectScatter',
          coordinateSystem: 'geo',
          data: ownProvienceDot,
          showEffectOn: 'emphasis',
          z: 1,
          rippleEffect: { brushType: 'stroke' },
          hoverAnimation: true,
          label: {
            normal: {
              formatter: '{b}',
              position: 'right',
              show: true,
              color: '#ffffff',
            },
          },
          itemStyle: {
            normal: {
              color: '#FFE800',
              shadowBlur: 10,
              shadowColor: '#FFE800',
            },
          },
          zlevel: 1,
        },
      ],
      visualMap: {
        min: 0,
        max: 11,
        left: 'left',
        top: 'bottom',
        text: ['高', '低'],
        calculable: true,
        seriesIndex: '1',
        show: false,
        inRange: { color: ['#89BDE6', '#2185C7'] },
      },
    };

    return option;
  };

  setMapCharts = opt => {
    echarts.registerMap(opt.mapName, opt.mapData);
    if (!document.getElementById('mapChartLight')) return;
    this.myMapChart = echarts.init(document.getElementById('mapChartLight'));

    var defaultOpt = {
      mapName: 'china', // 地图展示
      goDown: false, // 是否下钻
      bgColor: 'rgba(0,0,0,0)', // 画布背景色
      activeArea: [], // 区域高亮,同echarts配置项
      data: [],
      // 下钻回调(点击的地图名、实例对象option、实例对象)
      callback: function(name, option, instance) {},
    };

    if (opt) opt = echarts.util.extend(defaultOpt, opt);

    this.setState({ name: [opt.mapName], idx: 0 });

    let option = this.setMapOption(opt, this.myMapChart);

    this.myMapChart.setOption(option);

    let _this = this;
    this.myMapChart.on('click', function(params) {
      let name = params.name;
      let _self = this;
      _this.clickMapChart(name, _self, this.myMapChart, opt, option);
    });
  };

  zoomAnimation = myChart => {
    var count = null;
    var zoom = function(per) {
      if (!count) count = per;
      count = count + per;
      myChart.setOption({
        geo: { zoom: count },
      });
      if (count < 1)
        window.requestAnimationFrame(function() {
          zoom(0.2);
        });
    };
    window.requestAnimationFrame(function() {
      zoom(0.2);
    });
  };

  initSeriesData = data => {
    var temp = [];
    for (var i = 0; i < data.length; i++) {
      var geoCoord = geoCoordMap[data[i].name];
      if (geoCoord) {
        temp.push({
          name: data[i].name,
          value: geoCoord.concat(data[i].value, data[i].level),
        });
      }
    }
    return temp;
  };

  createBreadcrumb = (myChart, option, name, opt) => {
    var cityToPinyin = {
      中国: 'zhongguo',
      河北: 'hebei',
      山西: 'shangxi',
      辽宁: 'liaoning',
      吉林: 'jilin',
      安徽: 'anhui',
      江西: 'jiangxi',
      河南: 'henan',
      湖北: 'hubei',
      湖南: 'hunan',
      广西: 'guangxi',
      四川: 'sichuan',
      贵州: 'guizhou',
      云南: 'yunnan',
      西藏: 'xizang',
      甘肃: 'gansu',
      新疆: 'xinjiang',
    };
    let _this = this;
    var breadcrumb = {
      type: 'group',
      id: name,
      left: pos.leftCur + pos.leftPlus,
      top: pos.top + 3,
      children: [
        {
          type: 'polyline',
          left: -90,
          top: -5,
          shape: { points: line },
          style: { stroke: '#2185C7', key: name },
          onclick: function() {
            var name = this.style.key;
            _this.resetOption(myChart, option, name, opt);
          },
        },
        {
          type: 'text',
          left: -68,
          top: 'middle',
          style: {
            text: name,
            textAlign: 'center',
            fill: style.textColor,
            font: style.font,
          },
          onclick: function() {
            var name = this.style.text;
            _this.resetOption(myChart, option, name, opt);
          },
        },
        {
          type: 'text',
          left: -68,
          top: 10,
          style: {
            name: name,
            text: cityToPinyin[name] ? cityToPinyin[name].toUpperCase() : '',
            textAlign: 'center',
            fill: style.textColor,
            font: '12px "Microsoft YaHei", sans-serif',
          },
          onclick: function() {
            var name = this.style.name;
            _this.resetOption(myChart, option, name, opt);
          },
        },
      ],
    };

    pos.leftCur += pos.leftPlus;
    return breadcrumb;
  };

  resetOption = (i, o, n, opt) => {
    let { name, idx, mapData } = this.state;
    let convertMapData = this.convertData(mapData);
    ownProvienceData.forEach(data => {
      let flag = true;
      convertMapData.forEach(item => {
        if (item.name === data.name) {
          flag = false;
          data.value = item.value + 100;
        }
        if (flag) data.value = 100;
      });
    });

    if (n === '中国') {
      if (o && o.geo) {
        o.geo.label = {
          //标签样式设置
          normal: { show: false, color: '#FFFFFF', verticalAlign: 'bottom' },
          //鼠标移上去的样式
          emphasis: { show: false, color: '#FFFFFF' },
        };
      }

      o.series = [
        {
          type: 'effectScatter',
          coordinateSystem: 'geo',
          showEffectOn: 'render',
          rippleEffect: { period: 15, scale: 4, brushType: 'fill' },
          hoverAnimation: true,
          itemStyle: { normal: { color: '#89BDE6' } },
          data: ownProvienceData,
        },
        {
          type: 'map',
          mapType: 'china',
          geoIndex: 0,
          label: { normal: { show: true }, emphasis: { show: true } },
          data: ownProvienceData,
        },
        {
          type: 'effectScatter',
          coordinateSystem: 'geo',
          data: ownProvienceDot,
          showEffectOn: 'emphasis',
          z: 1,
          rippleEffect: { brushType: 'stroke' },
          hoverAnimation: true,
          label: {
            normal: {
              formatter: '{b}',
              position: 'right',
              show: true,
              color: '#ffffff',
            },
          },
          itemStyle: {
            normal: {
              color: '#FFE800',
              shadowBlur: 10,
              shadowColor: '#FFE800',
            },
          },
          zlevel: 1,
        },
      ];
    }
    var breadcrumb = this.createBreadcrumb(i, o, n, opt);

    var j = name.indexOf(n);
    var l = o.graphic.length;
    if (j < 0) {
      o.graphic.push(breadcrumb);
      o.graphic[0].children[0].shape.x2 = 150;
      o.graphic[0].children[1].shape.x2 = 150;
      if (o.graphic.length > 2) {
        for (var x = 0; x < opt.data.length; x++) {
          if (n === opt.data[x].name + '市') {
            o.series[0].data = this.initSeriesData([opt.data[x]]);
            break;
          } else o.series[0].data = [];
        }
      }
      name.push(n);
      idx++;
    } else {
      o.graphic.splice(j + 2, l);
      if (o.graphic.length <= 2) {
        o.graphic[0].children[0].shape.x2 = 70;
        o.graphic[0].children[1].shape.x2 = 70;
        o.series[0].data = this.initSeriesData(opt.data);
      }
      name.splice(j + 1, l);
      idx = j;
      pos.leftCur -= pos.leftPlus * (l - j - 1);
    }

    o.geo.map = n;
    o.geo.zoom = 0.4;
    i.clear();
    i.setOption(o);
    this.zoomAnimation(i);
    opt.callback(n, o, i);
    this.setState({ name, idx });
  };
  loadMap = (_self, name, option, myChart, opt) => {
    const { provinces } = this.state;
    if (name) {
      const data = JSON.stringify(provinces[name]);
      if (data) {
        echarts.registerMap(name, data);
        this.resetOption(_self, option, name, opt);
        this.myMapChart.setOption(option);
      }
    }
  };

  clickMapChart = (name, _self, myChart, opt, option) => {
    let { mapData } = this.state;
    let convertMapData = this.convertData(mapData);
    ownProvienceData.forEach(data => {
      let flag = true;
      convertMapData.forEach(item => {
        if (item.name === data.name) {
          flag = false;
          data.value = item.value + 100;
        }
      });
      if (flag) data.value = 100;
    });
    let newOption = option;
    newOption.geo.label = {
      //标签样式设置
      normal: { show: true, color: '#FFFFFF', verticalAlign: 'bottom' },
      //鼠标移上去的样式
      emphasis: { show: true, color: '#FFFFFF' },
    };
    newOption.series = [
      {
        type: 'effectScatter',
        coordinateSystem: 'geo',
        showEffectOn: 'render',
        rippleEffect: { period: 15, scale: 4, brushType: 'fill' },
        hoverAnimation: true,
        itemStyle: { normal: { color: '#89BDE6' } },
        data: ownProvienceData,
      },
      {
        type: 'map',
        mapType: 'china',
        geoIndex: 0,
        label: { normal: { show: true }, emphasis: { show: true } },
        data: ownProvienceData,
      },
    ];
    this.loadMap(_self, name, newOption, myChart, opt);
  };

  handleChangeDatePicker = value => {
    this.setState({ datePickerType: value });
  };

  handleOpenChange = status => {
    if (status) this.setState({ isopen: true });
    else this.setState({ isopen: false });
  };

  handlePanelChange = value => {
    this.setState({ yearValue: value, isopen: false });
  };

  clearValue = () => {
    this.setState({ yearValue: null });
  };

  handleSearch = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        let date = '';
        if (values.datePickerType === 'month') {
          date = formatDate(values.monthDate, 'YYYY年MM月');
        } else {
          date = formatDate(values.yearDate, 'YYYY年');
        }
        this.setState({ showLoading: true, dateRange: date, name: [] });
        this.getBoardOtherData(this.state.currentProduct, values);
      }
    });
  };

  handleReset = () => {
    this.setState({ datePickerType: 'month' });
    this.props.form.resetFields();
    const _this = this;
    setTimeout(function() {
      _this.props.form.setFieldsValue({
        monthDate: moment(new Date(), 'YYYY年MM月'),
      });
    }, 10);
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { barData, title, chartHeight } = this.state;
    const { canvasHeight, mapHeight, mapCanvasHeight } = this.state;
    const noData = (
      <div className="noData">
        <span>暂无数据</span>
      </div>
    );
    return (
      <div className="form-bg">
        <ConnectedMenu toggleCollapsed={() => changeListWidth(this)} />
        <div className="theme-content">
          <ConnectedHeader
            toggleCollapsed={() => changeListWidth(this)}
            login={false}
            home={true}
          />
          <div className="theme-box">
            <div className="bread-crumb">
              <Breadcrumb>{breadItem(['数据看板', title])}</Breadcrumb>
            </div>
            <div className="box" style={{ width: this.state.listWidth }}>
              <Spin
                indicator={
                  <img src={loading} alt="" className="data-spin-img" />
                }
                className="data-spin-loading"
                spinning={this.state.showLoading}
              >
                <div className="data-search">
                  <Form layout="inline">
                    <Form.Item label="地区" colon={false}>
                      {getFieldDecorator('area', {})(
                        <Select
                          placeholder="全国"
                          allowClear={true}
                          style={{ width: '240px' }}
                        >
                          {provienceList.map((item, index) => (
                            <Option
                              value={`${item.value}-${item.name}`}
                              key={index}
                            >
                              {item.name}
                            </Option>
                          ))}
                        </Select>
                      )}
                    </Form.Item>
                    <Form.Item>
                      {getFieldDecorator('datePickerType', {
                        initialValue: 'month',
                      })(
                        <Select
                          allowClear={true}
                          style={{ width: '120px' }}
                          onChange={this.handleChangeDatePicker}
                        >
                          <Option value="month"> 选择月 </Option>
                          <Option value="year"> 选择年 </Option>
                        </Select>
                      )}
                    </Form.Item>
                    {this.state.datePickerType === 'month' ? (
                      <Form.Item>
                        {getFieldDecorator('monthDate', {})(
                          <MonthPicker
                            allowClear={true}
                            placeholder="请选择月份"
                            format="YYYY年MM月"
                          />
                        )}
                      </Form.Item>
                    ) : (
                      <Form.Item>
                        {getFieldDecorator('yearDate', {
                          initialValue: this.state.yearValue,
                        })(
                          <DatePicker
                            open={this.state.isopen}
                            mode="year"
                            placeholder="请选择年份"
                            format="YYYY年"
                            onOpenChange={this.handleOpenChange}
                            onPanelChange={this.handlePanelChange}
                            onChange={this.clearValue}
                            allowClear={true}
                          />
                        )}
                      </Form.Item>
                    )}
                    <Form.Item>
                      <Button
                        type="primary"
                        icon="search"
                        onClick={this.handleSearch}
                      >
                        搜索
                      </Button>
                      <Button
                        icon="redo"
                        className="form-btn-margin"
                        onClick={this.handleReset}
                      >
                        重置
                      </Button>
                    </Form.Item>
                  </Form>
                </div>
                <Row gutter={10} className="data-bars">
                  <Col span={6}>
                    <div className="data-bg data-bg1">
                      <div className="data-bar">
                        <p className="title"> 今日AI筛查数 </p>
                        <p className="num">
                          <CountUp
                            className="gmv-show-gmv"
                            start={0}
                            end={barData.aiCnt || 0}
                            duration={1}
                          />
                        </p>
                      </div>
                    </div>
                  </Col>
                  <Col span={6}>
                    <div className="data-bg data-bg2">
                      <div className="data-bar">
                        <p className="title"> 今日AI筛查阳性新增 </p>
                        <p className="num">
                          <CountUp
                            className="gmv-show-gmv"
                            start={0}
                            end={barData.aiPositiveCnt || 0}
                            duration={1}
                          />
                        </p>
                      </div>
                    </div>
                  </Col>
                  <Col span={6}>
                    <div className="data-bg data-bg3">
                      <div className="data-bar">
                        <div className="title"> 今日医生审核 </div>
                        <p className="num">
                          <CountUp
                            className="gmv-show-gmv"
                            start={0}
                            end={barData.doctorCnt || 0}
                            duration={1}
                          />
                        </p>
                      </div>
                    </div>
                  </Col>
                  <Col span={6}>
                    <div className="data-bg data-bg4">
                      <div className="data-bar">
                        <div className="title">今日医生审核肺结核阳性新增</div>
                        <p className="num">
                          <CountUp
                            className="gmv-show-gmv"
                            start={0}
                            end={barData.doctorPositiveCnt || 0}
                            duration={1}
                          />
                        </p>
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row gutter={10} className="data-charts">
                  <Col span={6}>
                    <div
                      className="data-chart"
                      style={{ height: chartHeight, marginBottom: '10px' }}
                    >
                      <div className="title">
                        <span className="name"> 阳性患者画像 </span>
                        <Icon type="double-right" />
                        <span className="selected-date">
                          {this.state.dateRange}
                        </span>
                      </div>
                      <div
                        className="chart"
                        id="sexChartLight"
                        style={{ height: canvasHeight }}
                      ></div>
                    </div>
                    <div className="data-chart" style={{ height: chartHeight }}>
                      <div className="title">
                        <span className="name"> AI最近7日筛查人数 </span>
                      </div>
                      <div
                        className="chart"
                        id="increaseChartLight"
                        style={{ height: canvasHeight }}
                      ></div>
                    </div>
                  </Col>
                  <Col
                    span={12}
                    style={{
                      height: mapHeight,
                    }}
                  >
                    <div className="data-chart">
                      <div className="title">
                        <span className="name"> 医疗机构业务分布 </span>
                        <Icon type="double-right" />
                        <span className="selected-date">
                          {this.state.dateRange}
                        </span>
                      </div>
                      <div
                        className="chart"
                        id="mapChartLight"
                        style={{ height: mapCanvasHeight }}
                      ></div>
                    </div>
                  </Col>
                  <Col span={6}>
                    <div
                      className="data-chart"
                      style={{ height: chartHeight, marginBottom: '10px' }}
                    >
                      <div className="title">
                        <span className="name"> 传片量TOP </span>
                        <Icon type="double-right" />
                        <span className="selected-date">
                          {this.state.dateRange}
                        </span>
                      </div>
                      {this.state.aiStat.length === 0 && noData}
                      <div
                        className="chart"
                        id="rankChartLight"
                        style={{ height: canvasHeight }}
                      ></div>
                    </div>
                    <div className="data-chart" style={{ height: chartHeight }}>
                      <div className="title">
                        <span className="name"> AI筛查阳性数TOP </span>
                        <Icon type="double-right" />
                        <span className="selected-date">
                          {this.state.dateRange}
                        </span>
                      </div>
                      {this.state.aiStat.length === 0 && noData}
                      <div
                        className="chart"
                        id="yangRankChartLight"
                        style={{ height: canvasHeight }}
                      ></div>
                    </div>
                  </Col>
                </Row>
              </Spin>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Form.create()(DataForm));
